import { render } from "./NachaExport.vue?vue&type=template&id=315c48b6&scoped=true"
import script from "./NachaExport.vue?vue&type=script&lang=js"
export * from "./NachaExport.vue?vue&type=script&lang=js"

import "./NachaExport.vue?vue&type=style&index=0&id=315c48b6&scoped=true&lang=css"
import "./NachaExport.vue?vue&type=style&index=1&id=315c48b6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-315c48b6"]])

export default __exports__